import { render } from "./NoPermissionMessage.vue?vue&type=template&id=11dcf516&scoped=true"
import script from "./NoPermissionMessage.vue?vue&type=script&lang=js"
export * from "./NoPermissionMessage.vue?vue&type=script&lang=js"

import "./NoPermissionMessage.vue?vue&type=style&index=0&id=11dcf516&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11dcf516"]])

export default __exports__